import { render, staticRenderFns } from "./d2-crud.vue?vue&type=template&id=4570b7aa&scoped=true&"
import script from "./d2-crud.vue?vue&type=script&lang=js&"
export * from "./d2-crud.vue?vue&type=script&lang=js&"
import style0 from "./d2-crud.vue?vue&type=style&index=0&id=4570b7aa&lang=scss&scoped=true&"
import style1 from "./d2-crud.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570b7aa",
  null
  
)

export default component.exports